export const JSONEncode = (data: any, indent: null | number = null) =>
  JSON.stringify(data, null, indent ?? undefined)
